import React from "react";
import "./ProjectCard2.css";
import { urlFor } from "../../client";

const ProjectCard2 = ({ featuredProjects }) => {
  return (
    <section className="projects-section-container" id="projects">
      <div className="projects-section-div">
        <div className="section-heading" data-aos="fade-up">
          <h2
            className="section-heading-article"
            tabIndex="0"
            aria-label="Featured Projects"
          >
            &#60;/Featured Projects&#62;
          </h2>
          <p className="sectionHeadingP"></p>
        </div>
        <div className="project-boxes-div">
          {/* Mapping through featuredProjects array */}
          {featuredProjects.map((project, index) => (
            <div className="project-box-wrapper" data-aos="fade-up" key={index}>
              <div
                className="project-box project-box1"
                id={`project-box${index + 1}`}
              >
                <div className="info-div">
                  <img
                    src={urlFor(project.faviconUrl)}
                    alt={project.title}
                    className="faviconforProject"
                  />
                  <article className="ProjectHeading">{project.title}</article>
                  <p className="ProjectDescription">
                    {project.shortDescription
                      ? project.shortDescription
                      : project.description}
                  </p>
                  <div className="project-buttons">
                    <a
                      href={project.githubUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="github-redirect"
                      aria-label={`Visit ${project.title} on GitHub`}
                    >
                      <img
                        src="./assets/images/svg/github.svg"
                        alt="GitHub redirect button"
                      />
                    </a>
                    <a
                      href={project.projectLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cta"
                      aria-label={`Visit ${project.title} live`}
                    >
                      <span>Live view</span>
                      <svg viewBox="0 0 13 10" height="10px" width="15px">
                        <path d="M1,5 L11,5"></path>
                        <polyline points="8 1 12 5 8 9"></polyline>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="image-div">
                  <img
                    src={urlFor(project.imgUrl)}
                    alt={`${project.title} preview`}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="section-heading" data-aos="fade-up">
          <h2
            className="section-heading-article"
            tabIndex="0"
            aria-label="Other Projects"
          >
            &#60;/Other Projects&#62;
          </h2>
          <p className="sectionHeadingP"></p>
        </div>
      </div>
    </section>
  );
};

export default ProjectCard2;
